"use client";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useAtom } from "jotai";
import { agentsFiltersAtom } from "@/app/(saas)/(app)/business-brokers/_components/filters/state";
import { AgentIndustryFilter } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-industry-filter";
import { cn } from "@/lib/utils";

export function AgentIndustryFilterPopover() {
  const [filters, setFilters] = useAtom(agentsFiltersAtom);
  const isActive = filters.specialtyIds.length > 0;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "h-9 rounded-full text-sm px-4 border transition-colors",
            isActive
              ? "bg-[var(--venturu-green-soft)] border-[var(--venturu-green-soft)] text-[var(--venturu-black)]"
              : "border-[var(--venturu-gray-100)] hover:border-[var(--venturu-gray-300)]",
          )}
        >
          Industry
          {isActive && (
            <span className="ml-1 text-xs font-semibold bg-[var(--venturu-green)] text-white rounded-full size-5 flex items-center justify-center">
              {filters.specialtyIds.length}
            </span>
          )}
          <Icon icon="ChevronDown" className="size-3.5 ml-1" />
          {isActive && (
            <button
              type="button"
              className="ml-1 hover:bg-black/5 rounded-full p-0.5"
              onClick={(e) => {
                e.stopPropagation();
                setFilters((prev) => ({
                  ...prev,
                  specialtyIds: [],
                }));
              }}
            >
              <Icon icon="XClose" className="size-3" />
            </button>
          )}
        </Button>
      </PopoverTrigger>

      <PopoverContent align="start" className="p-0 w-[416px] relative">
        <AgentIndustryFilter />
      </PopoverContent>
    </Popover>
  );
}

AgentIndustryFilterPopover.displayName = "AgentIndustryFilterPopover";
